import { createFileRoute } from '@tanstack/react-router';

import { queries } from '../common/api/queryKeys/queries';
import { SupplierCompaniesPage } from '../group/supplier/companies/SupplierCompaniesPage';

export const Route = createFileRoute('/_app/supplier-groups/$groupId/companies/')({
    component: SupplierCompaniesPage,
    async loader({ params, context }) {
        return context.queryClient.ensureQueryData(queries.suppliers.list({ groupId: params.groupId }));
    },
});
